import React from 'react';
import { LuFilter } from 'react-icons/lu';
import Footer from '../../../footer';
import { Button, Table } from 'react-bootstrap'; 
import Header from '../../../header/header';
import Navvbar from '../../../header/Navvbar';
// import Filter from '../../screens/cases/Filter.js';

const CaseEstimates = () => {
  return (
    <>
      {/* 🏷️ Logo component at the top */}
      <Header />
<Navvbar/>
      {/* 📄 Main content container */}
      <div style={{ marginTop: '20px', width: '95%', margin: '0 auto', padding: '20px' }}>
        
        {/* 🧾 Page heading + Filter Button */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2>Case Plans / Estimates (£ 0.00)</h2>
          <div>
            <button
              style={{
                padding: '5px',
                backgroundColor: '#004aad',
                color: 'white',
                width: '90px',
                height: '40px',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              <LuFilter /> Filters
            </button>
          </div>
        </div>

        {/* 📊 Table to show cases */}
        <Table bordered hover style={{ width: "100%", border: '3px solid #f4f4f4', borderRadius: '5px' }}>
          <thead>
            <tr>
              <th>Case/Pan</th>
              <th></th>
              <th>Estimate</th>
              <th>Account</th>
              <th>Provider</th>
              <th>Patient/Appt</th>
              <th>Account Ship</th>
              <th>Lab Ship</th>
              <th>Delivery</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={9} style={{ textAlign: 'center' }}>
                There are no records to show
              </td>
            </tr>
          </tbody>
        </Table>

        {/* 📃 Pagination buttons (static) */}
        <div style={{ display: 'flex', marginTop: '20px', width: '100%' }}>
          <Button style={{ flex: 1, backgroundColor: "#f0f0f0", borderColor: "#ced4da", color: "black", borderRadius: '0' }}>First</Button>
          <Button style={{ flex: 1, backgroundColor: "#f0f0f0", borderColor: "#ced4da", color: "black", borderRadius: '0' }}>Previous</Button>
          <Button style={{ flex: 1, backgroundColor: "#004aad", borderColor: "#004aad", color: "white", borderRadius: '0' }}>1</Button>
          <Button style={{ flex: 1, backgroundColor: "#f0f0f0", borderColor: "#ced4da", color: "black", borderRadius: '0' }}>Next</Button>
          <Button style={{ flex: 1, backgroundColor: "#f0f0f0", borderColor: "#ced4da", color: "black", borderRadius: '0' }}>Last</Button>
        </div>
      </div>

      {/* 📦 Footer at the bottom */}
      <div style={{ width: '95%', margin: '0 auto', padding: '0px' }}>
        <Footer />
      </div>

      {/* 🎛️ Filter modal component (static)
      <Filter /> */}
    </>
  );
};

export default CaseEstimates;